import React, { createContext, useContext } from "react";
import rootStore, { RootStore } from "./RootStore";

const StoreContext = createContext<RootStore | null>(null);

export const StoreProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <StoreContext.Provider value={rootStore}>{children}</StoreContext.Provider>
  );
};

export const useStore = () => {
  const context = useContext(StoreContext);
  if (!context) {
    throw new Error("useStore must be used within a StoreProvider");
  }
  return context;
};
export const useMatchListStore = () => {
  const { matchListStore } = useStore();
  return matchListStore;
};

export const useNationalLeagueStore = () => {
  const { nationalLeagueStore } = useStore();
  return nationalLeagueStore;
};
export const useCreateLeagueMatchStore = () => {
  const { createLeagueMatchStore } = useStore();
  return createLeagueMatchStore;
};
